import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import * as styles from './ExpandableContainer.scss';

var ExpandableContainer = /*#__PURE__*/function (_Component) {
  _inherits(ExpandableContainer, _Component);

  var _super = _createSuper(ExpandableContainer);

  function ExpandableContainer(props) {
    var _this;

    _classCallCheck(this, ExpandableContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      _this.setState({
        height: _this.state.height === 0 ? 'auto' : 0
      });
    });

    _this.state = {
      height: props.height
    };
    return _this;
  }

  _createClass(ExpandableContainer, [{
    key: "render",
    value:
    /** *********************************************************************************************
     RENDER METHODS
    ************************************************************************************************/
    function render() {
      var arrowClass = this.state.height === 0 ? 'ion-ios-arrow-down' : 'ion-ios-arrow-up';
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.title
      }, this.props.title), /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.toggleIcon, " icon ").concat(arrowClass),
        onClick: this.handleToggle
      })), /*#__PURE__*/React.createElement(AnimateHeight, {
        duration: 500,
        height: this.state.height
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrap
      }, this.props.children)));
    }
  }]);

  return ExpandableContainer;
}(Component);

_defineProperty(ExpandableContainer, "defaultProps", {
  height: 'auto',
  style: {}
});

export { ExpandableContainer as default };